const themes = () => (['default', 'vivo']);

export default {
  namespaced: true,
  state: {
    theme: 'default',
  },
  actions: {
    async setTheme({ commit }, theme) {
      commit('setTheme', themes().includes(theme) ? theme : 'default');
    },
  },
  mutations: {
    setTheme(state, theme) {
      state.theme = theme;
    },
  },
};
